import http from '@/util/http'

class InvitationAcceptApi {
  //获取领导列表
  getLeaderList(params) {
    var url = '/share-foreign/approval/getMatrixUserList';
    return http.post(url, params);
  }
  //我发起的邀请函审批列表
  getLaunchList(params) {
    var url = '/share-foreign/approval/getMystartPage';
    return http.post(url, params);
  }
  //邀请函审批列表
  getApprovalList(params) {
    var url = '/share-foreign/approval/getApprovalPage';
    return http.post(url, params);
  }
  todoList(params) {
    var url = '/share-foreign/workflow/stateItemInfo/todoList';
    return http.post(url, params);
  }
  //邀请函审批
  approvalInvitation(params) {
    var url = '/share-foreign/approval/approval';
    return http.post(url, params);
  }
  //邀请函 选择其他领导审批
  handOtherApproval(params) {
    var url = '/share-foreign/approval/selectOtherLeader';
    return http.post(url, params);
  }
  //邀请函审批信息 日志
  getApprovalInfos(params) {
    var url = '/share-foreign/approval/getApprovalLogs';
    return http.post(url, params);
  }
  // 邀请函管理 --  单个查询
  getOneInviAppLy(params) {
    var url = '/share-foreign/invi/getOneInviAppLy';
    return http.post(url, params);
  }
  // 判断新旧---查工作流类型,返回0是suboa，返回1是云枢
  getWorkFlowType(params) {
    var url = '/share-foreign/workflow/stateItemInfo/getWorkFlowType?itemInfoId=' + params.itemInfoId;
    return http.get(url);
  }
}

export default InvitationAcceptApi
